import { render, staticRenderFns } from "./AlbumImage.vue?vue&type=template&id=938ebe7e&scoped=true&lang=pug&"
import script from "./AlbumImage.vue?vue&type=script&lang=js&"
export * from "./AlbumImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938ebe7e",
  null
  
)

export default component.exports